import React from 'react';

function Button(props) {

  const handleClick = () => {

        if (props.onClick) {
            props.onClick(); 
        }

  };


    return (
      <>
        <div className='button_wrapper'>
            <button type={props.type} className={props.class} onClick={handleClick}>
                {props.text}
            </button>
        </div>    
      </>
    );
}

export default Button;